import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useCrispVisibility = () => {
  const location = useLocation();

  useEffect(() => {
    const hidePages = [
      "/login",
      "/onboarding/plan",
      "/billing/success",
      "/dashboard/data-chat",
    ];
    const hidePatterns = [/^\/register\/.+$/];

    const tryShowHideChat = () => {
      const shouldHide =
        hidePages.includes(location.pathname) ||
        hidePatterns.some((pattern) => pattern.test(location.pathname));

      if ((window as any).$crisp) {
        if (shouldHide) {
          (window as any).$crisp.push(["do", "chat:hide"]);
        } else {
          (window as any).$crisp.push(["do", "chat:show"]);
        }
      } else {
        setTimeout(tryShowHideChat, 500);
      }
    };

    tryShowHideChat();
  }, [location.pathname]);
};

export default useCrispVisibility;
